<template>
    <div class="checkbox-container">
        <label
            @click="emitClick($event)"
            class="checkbox-label"
            :for="id">
            <input
                type="checkbox"
                :id="id"
                :name="name"
                :value="value"
                :checked="value === checkedValue"
                v-validate="required === true ? 'required' : '' "
                :required="required"
                @click="emitClick($event)"
                @input="updateInput($event)"
                @change="changeInput($event)">
            <span
                class="checkmark"></span>
            <div v-html="text"></div>
            <slot></slot>
        </label>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    inject: ['$validator'],
    props: ['value', 'id', 'text', 'name', 'checkedValue', 'required'],
    methods: {
        changeInput (e) {
            this.$emit('change', e)
        },
        updateInput (e) {
            this.$emit('input', e)
        },
        emitClick (e) {
            this.$emit('click', e)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@VARIABLES";

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: 0;
}
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: white;
  border: 1px solid black;
  border-radius: 3px;
}
/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color:#dddbdc;
}
/* When the checkbox is checked, add a red background */
.checkbox-container input:checked ~ .checkmark {
  background-color: $system-color;
}
/* Error when is required and not check */
.checkbox-container input[aria-invalid=true] ~ .checkmark {
  border: 1px solid red;
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}
/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
    display: block;
}
/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 7px;
    height: 12px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.checkbox-label {
    display: flex;
    padding-left: 12px;
    font-size: 13px;
}
</style>
